import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import style from "../../assets/jss/disal-main/components/Modal";
import TableContainer from "@material-ui/core/TableContainer";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles(style);

const Modals = ({ openModal1, handleClose, namePoint, datamodal }) => {
  const classes = useStyles();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openModal1}
      onClose={handleClose}
      closeAfterTransition
      disableScrollLock
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={openModal1}>
        <div className={classes.paper}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className={classes.modalHeader}>
                <h5
                  className={classes.modalTitle}
                  id="exampleModalLabel"
                >
                  Mostrando resultados para el Punto Generador{" "}
                  <span>
                    {namePoint === 0 ? "-" : namePoint}
                  </span>
                </h5>
                <button
                  className="btn-close"
                  onClick={handleClose}
                >
                  <span className="closeSpan big"></span>
                </button>
              </div>
              <div className="modal-body table-responsive">
                <TableContainer className={classes.contentModal}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell> #</TableCell>
                        <TableCell>TIPO DE CONTENEDOR</TableCell>
                        <TableCell>MATERIAL</TableCell>
                        <TableCell>VOLUMEN</TableCell>
                        <TableCell>PESO</TableCell>
                        <TableCell>SEGREGACIÓN</TableCell>
                        <TableCell>FOTO ANTES</TableCell>
                        <TableCell>FOTO DESPUÉS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {datamodal.map((dat, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>
                          <TableCell>{dat.containerModel}</TableCell>
                          <TableCell>{dat.residualSubtype}</TableCell>
                          <TableCell>{parseFloat(dat.volume).toFixed(3)}</TableCell>
                          <TableCell>{parseFloat(dat.weight).toFixed(1)}</TableCell>
                          <TableCell>
                            <span className={"statusModal " + dat.hasIncident}>
                              {dat.hasIncident}
                            </span>
                          </TableCell>
                          <TableCell>
                            {dat.photoBefore && (
                              <a
                                href={dat.photoBefore}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Ver
                              </a>
                            )}
                          </TableCell>
                          <TableCell>
                            {dat.photoAfter && (
                              <a
                                href={dat.photoAfter}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Ver
                              </a>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default Modals;
